export enum ShowingType {
  SHOWING_TYPE_PRIVATE = "SHOWING_TYPE_PRIVATE",
  SHOWING_TYPE_PUBLIC = "SHOWING_TYPE_PUBLIC",
  SHOWING_TYPE_FIRST_SHOWING = "SHOWING_TYPE_FIRST_SHOWING",
}
